import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Practice Areas', href: '#practice-areas' },
  { label: 'About', href: '#about' },
  { label: 'Commitment', href: '#commitment' },
  { label: 'Contact', href: '#contact' },
];

const practiceLinks = [
  'Family Law',
  'Matrimonial Law',
  'Estate Law',
  'Corporate Disputes',
  'Personal Injury',
  'Real Estate',
];

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.getElementById(href.replace('#', ''));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="relative pt-20 pb-8 overflow-hidden" style={{ background: '#0B132B' }}>
      {/* Top Gradient Line */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #06B6D4, transparent)' }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 rounded-md flex items-center justify-center font-heading font-bold text-lg"
                style={{ background: 'linear-gradient(135deg, #1D4ED8, #06B6D4)', color: '#fff' }}
              >
                F
              </div>
              <span className="font-heading font-bold text-lg text-white tracking-tight">
                Fitzgerald<span className="text-cyan-bright">&</span>Associates
              </span>
            </div>
            <p className="font-body text-sm text-white/50 leading-relaxed mb-6">
              New York&apos;s premier law firm, dedicated to protecting your rights and
              delivering exceptional legal solutions.
            </p>
            {/* REPLACE: social links with actual URLs */}
            <div className="flex gap-3">
              {[
                { name: 'Facebook', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                { name: 'LinkedIn', path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
                { name: 'Twitter', path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
                { name: 'Instagram', path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
              ].map(social => (
                <a
                  key={social.name}
                  href={`#${social.name.toLowerCase()}`} /* REPLACE WITH ACTUAL SOCIAL URL */
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-white/5 border border-white/10 transition-all duration-300 hover:bg-cyan-bright/20 hover:border-cyan-bright/40"
                  aria-label={social.name}
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white/60 hover:fill-cyan-bright transition-colors">
                    <path d={social.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm text-white tracking-wide uppercase mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map(link => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="font-body text-sm text-white/50 hover:text-cyan-bright transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Practice Areas */}
          <div>
            <h4 className="font-heading font-bold text-sm text-white tracking-wide uppercase mb-5">Practice Areas</h4>
            <ul className="space-y-3">
              {practiceLinks.map(area => (
                <li key={area}>
                  <button
                    onClick={() => scrollTo('#practice-areas')}
                    data-testid={`footer-practice-${area.toLowerCase().replace(/\s/g, '-')}`}
                    className="font-body text-sm text-white/50 hover:text-cyan-bright transition-colors"
                  >
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-sm text-white tracking-wide uppercase mb-5">Contact Us</h4>
            <div className="space-y-4">
              <a href="tel:+19176244469" className="flex items-center gap-3 group" data-testid="footer-phone">
                <Phone size={14} className="text-cyan-bright" />
                <span className="font-body text-sm text-white/50 group-hover:text-cyan-bright transition-colors">(917) 624-4469</span>
              </a>
              {/* REPLACE: email with actual firm email */}
              <a href="mailto:Almanzar@fitzgerald-law.com" className="flex items-center gap-3 group" data-testid="footer-email">
                <Mail size={14} className="text-cyan-bright" />
                <span className="font-body text-sm text-white/50 group-hover:text-cyan-bright transition-colors">Almanzar@fitzgerald-law.com</span>
              </a>
              {/* REPLACE: address with actual firm address */}
              <div className="flex items-start gap-3" data-testid="footer-address">
                <MapPin size={14} className="text-cyan-bright mt-0.5" />
                <span className="font-body text-sm text-white/50">New York, NY<br />Serving Queens & Bronx</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="font-body text-xs text-white/30">
              &copy; {new Date().getFullYear()} Fitzgerald & Associates. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button className="font-body text-xs text-white/30 hover:text-white/60 transition-colors" data-testid="footer-privacy">Privacy Policy</button>
              <button className="font-body text-xs text-white/30 hover:text-white/60 transition-colors" data-testid="footer-terms">Terms of Service</button>
            </div>
          </div>
        </div>

        {/* Large Brand Text */}
        <div className="mt-12 text-center overflow-hidden">
          <span className="font-heading font-bold text-[8vw] md:text-[6vw] text-white/[0.03] tracking-tight leading-none select-none">
            FITZGERALD
          </span>
        </div>
      </div>
    </footer>
  );
}
